import { render } from "./ImageUpload.vue?vue&type=template&id=1580893a&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=1580893a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1580893a"

export default script